<template>
  <BaseButton
    v-bind="mergedAttrs"
    :prepend-icon="prependIcon"
    :append-icon="appendIcon"
    :class="{
      active,
      rounded,
      'rounded-start': roundedStart,
      'rounded-end': roundedEnd
    }"
    class="v3-pill-button"
    :is-disabled="isDisabled"
    :native-id="tabMode ? tabId : ''"
    :native-role="tabMode ? 'tab' : ''"
    :aria-selected="tabMode ? (isTabSelected ? 'true' : 'false') : undefined"
    @click="$emit('click', $event)"
  >
    <slot></slot>
    <div v-if="showSubTitle" class="subtitle">{{ subTitle }}</div>
  </BaseButton>
</template>

<script>
import { computed, useAttrs } from "vue"
import BaseButton from "./BaseButton.vue"

export default {
  inheritAttrs: false,
  components: { BaseButton },
  emits: ["click"],
  props: {
    prependIcon: String,
    appendIcon: String,
    active: Boolean,
    rounded: Boolean,
    roundedStart: Boolean,
    roundedEnd: Boolean,
    showSubTitle: Boolean,
    subTitle: String,
    isDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Set `true` only for toggle (pressed/unpressed) controls. Ignored when `tabMode` is true.
     */
    useAriaPressed: {
      type: Boolean,
      default: false
    },
    /** When true, pill acts as `role="tab"` (use with `role="tablist"`). */
    tabMode: {
      type: Boolean,
      default: false
    },
    isTabSelected: {
      type: Boolean,
      default: false
    },
    tabId: {
      type: String,
      default: ""
    },
    /**
     * Explicit tabindex so it always reaches the native button inside BaseButton
     * (avoids losing focus order when attrs fallthrough is subtle).
     */
    tabindex: {
      type: [String, Number],
      default: undefined
    }
  },
  setup(props) {
    const attrs = useAttrs()
    const ariaPressedAttrs = computed(() => {
      if (props.tabMode || !props.useAriaPressed) return {}
      return { "aria-pressed": props.active ? "true" : "false" }
    })
    const mergedAttrs = computed(() => {
      const base = {
        ...attrs,
        ...ariaPressedAttrs.value
      }
      if (props.tabindex !== undefined && props.tabindex !== null) {
        base.tabindex = props.tabindex
      }
      return base
    })
    return { mergedAttrs }
  }
}
</script>

<style>
.subtitle {
  font-size: 10px;
}
</style>
